// extracted by mini-css-extract-plugin
module.exports = {"header":"SeasonalActivities_header__iPMjM","icon":"SeasonalActivities_icon__D9sDF","section":"SeasonalActivities_section__6nITH"};